import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useFeature from 'hooks/useFeature';

import { selectTenant, FeatureGroups } from 'state/tenant';

const useStartPageName = () => {
  const { isGroupEnabled } = useFeature();
  const {
    enabledFeatures: { cardChoices },
  } = useSelector(selectTenant);

  const startRoute = useMemo(() => {
    const hasCardChoice = cardChoices.length > 0;

    const hasConsumerSearch = isGroupEnabled(FeatureGroups['consumer-search']);

    if (hasCardChoice) {
      return 'card-choice';
    } else if (hasConsumerSearch) {
      return 'consumer-search';
    } else {
      return 'credit-application';
    }
  }, [cardChoices, isGroupEnabled]);

  return startRoute;
};

export default useStartPageName;
